import { useCookies } from "vue3-cookies"

const toStoredValue = (value: any) => {
  if (value === undefined || value === null) return ""
  if (typeof value === "string") return value
  return String(value)
}

const readLegacyCookie = (key: string) => {
  try {
    const { cookies } = useCookies()
    const val = cookies.get(key)
    if (val === undefined || val === null || val === "") return null
    return val
  } catch {
    return null
  }
}

const removeLegacyCookie = (key: string) => {
  try {
    const { cookies } = useCookies()
    cookies.remove(key)
  } catch {
    // ignore
  }
}

const cookiesConFig = {
  setCokies(key: any, value: any) {
    localStorage.setItem(String(key), toStoredValue(value))
    removeLegacyCookie(String(key))
  },
  removeCokies(key: any) {
    localStorage.removeItem(String(key))
    removeLegacyCookie(String(key))
  },
  getCokies(key: any) {
    const storageKey = String(key)
    const stored = localStorage.getItem(storageKey)
    if (stored !== null && stored !== "") return stored

    const legacy = readLegacyCookie(storageKey)
    if (legacy !== null) {
      localStorage.setItem(storageKey, toStoredValue(legacy))
      removeLegacyCookie(storageKey)
      return legacy
    }

    return stored ?? ""
  },
  getCokiesBoolean(key: any) {
    const val = cookiesConFig.getCokies(key)
    return val === "true"
  },
}

export default cookiesConFig
